// 申請状況照会のラベル
export const LABELS = {
  EMPTY: "　",
  APPLICATION_START_DATE: "申請日　",
  ANSWER_START_TIME: "回答日時",
  APPLICATION_START: "～",
  SERVICE_NAME: "サービス名",
  COMPANY_NAME: "事業者名",
  MERCHANTS_NAME: "加盟店名",
  CONTRACT_STATUS: "契約形態",
  CONTRACT_ROUTE: "契約ルート",
  CONTRACT_DIRECTLY: "直接",
  CONTRACT_COMPREHENSIVE: "包括",
  APPLICATION_RELATIVE: "個別料率",
  APPLICATION_STATUS: "申請ステータス",
  APPLICATION_STATUS_APPLYING: "申請中のみ",
  APPLICATION_STATUS_UNSETTLED: "営業未確認",
  APPLICATION_STATUS_UNSETTLED_NG: "審査NG・未確認",
  APPLICATION_STATUS_NOT_COMPATIBLE: "個別相談未対応",
  APPLICATION_STATUS_ALL: "全て",
  APPLICATION_NO: "申請番号",
  PARTICULAR_RATE_FLAG: "特別料率　　　　　　",
  MERCHANT_ANSWERED: "加盟店回答　　　　　",
  NOT_SELECTED: "未選択",
  ALL: "ALL",
  RELATIVE_YES: "有",
  RELATIVE_NO: "無",
  APPLICATION_TYPE: "申請種別",
  APPLICATION_FORM_TYPE: "申請書種別",
  APPLICATION_STATUS_TITLE: "申請状況",
  APPLICATION_STATUS_DETAILS: "申請状況詳細",
  APPLICANT: "申請者種別",
  APPLICANT_EMAIL: "申請者メールアドレス",
  SITE_ID: "サイトID",
  DONE: "済",
} as const;

// メールアドレス最大文字数
export const MAX_SIZE_MAIL = 100;

//加盟店名最大文字数
export const MAX_SIZE_MERCHANTS = 100;

// サイトIDの最大文字数
export const MAX_SIZE_CPID = 11;

// 文字列分割用
export const SLASH = "　/　";

// プレースホルダーの内容
export const PLACE_APPLICATION = {
  DATE_FORMAT: "YYYY/MM/DD",
  FONT_SIZE: "30文字以内",
  FONT_SIZE_MERCHANTS: "100文字以内",
  FONT_SIZE_EMAIL: "100文字以内",
  FONT_SIZE_CPID: "半角数字11桁以内",
} as const;

// SELECTの空行の定義
export const SELECT_BLANK = { label: "　　　　", value: "" };

export const PARTICULAR_RATE_FLAG_LIST = [
  { label: LABELS.NOT_SELECTED, value: "" },
  { label: LABELS.RELATIVE_YES, value: "01" },
  { label: LABELS.RELATIVE_NO, value: "02" },
];

/**
 * 権限毎の申請状況詳細項目表示リストを返却する.
 * @param {boolean} isDocomoUser ドコモユーザか
 * @param {boolean} hasAuthority マスタ編集権限があるか
 * @returns {string[]} 申請状況詳細項目表示リスト
 */
export const getAppDetailStatusList = (
  isDocomoUser: boolean,
  hasAuthority: boolean | undefined
): string[] => {
  if (isDocomoUser) {
    if (hasAuthority) {
      return ["01", "02", "05", "06"];
    } else {
      return ["01"];
    }
  }
  return [];
};

// 申請者種別項目表示リスト
export const DOCOMO_APPLICANT_USER_TYPE_LIST = ["01", "02", "03", "04"];
